import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../template/layout/core'
import {ListCSRPage} from './ListCSRPage'

const CSRWrapper: FC = () => {
  const intl = useIntl()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'APPS.CSR'})}</PageTitle>
      <ListCSRPage />
    </>
  )
}

export {CSRWrapper}
